/* tslint:disable */
/* eslint-disable */

import _Vue from 'vue';
import { MUTATIONS } from '@/store/namespaces';
import { DriverStatusEnum } from '@/services/api-clients';
import store from '../store';

export interface ReasonPromptResult {
  saved: boolean;
  reason: string;
}

class ReasonPrompt {
  install(Vue: typeof _Vue, options?: any) {
    Vue.prototype.$reasonPrompt = (statusId: DriverStatusEnum, reason: string = ''): Promise<ReasonPromptResult> => {
      store.commit(MUTATIONS.SHOW_REASON_PROMPT, { statusId, reason });
      return new Promise<ReasonPromptResult>((resolve) => {
        store.subscribe((mutation, state) => {
          if (mutation.type === MUTATIONS.FINISH_REASON_PROMPT && state.reasonPrompt.result !== null) {
            resolve(state.reasonPrompt.result);
          }
        });
      });
    }
  }
}

declare module 'vue/types/vue' {
  interface Vue {
    $reasonPrompt: (statusId: DriverStatusEnum, reason?: string) => Promise<ReasonPromptResult>
  }
}

export default new ReasonPrompt();
